import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArkUnitOfWork, AppInformationService, AuthService } from 'app/core/core.module';
import { ContributionBatch, OfferingSchedule } from 'app/core/model/entity-model';
import _ from 'lodash';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-offering-schedule-dialog',
    templateUrl: './offering-schedule-dialog.component.html',
    styleUrls: ['./offering-schedule-dialog.component.scss'],
    standalone: false,
})
export class OfferingScheduleDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    mode: any;
    specialAccounts: any[];
    offeringScheduleId: number;
    offeringSchedule: OfferingSchedule;
    offeringDate: Date;
    validationGroup = 'validationGroup';
    errorAction = 'saving';

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        this.specialAccounts = await this.uow.getAccounts();
        if (this.mode === 'new') {
            this.offeringSchedule = this.uow.offeringSchedules.createEntity();
            this.offeringSchedule.offeringDate = this.offeringDate;
            this.offeringSchedule.created = new Date();
            this.offeringSchedule.createdBy = this.auth.currentUser.userName;
        }
        else {
        }
    }

    aMChange(e) {
        if (this.offeringSchedule.aMOffering) this.offeringSchedule.pMOffering = false;
    };
    pMChange(e) {
        if (this.offeringSchedule.pMOffering) this.offeringSchedule.aMOffering = false;
    }

    async save() {
        const result = this.validate();
        if (!result) return;
        await this.uow.commit();
        this.result.next({ success: true, offeringSchedule: this.offeringSchedule.id });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    cancel() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
